export default "__VITE_ASSET__39cyPV26__"